

exports.__esModule = true;
exports.$ReviewRoute = undefined;

var _squid = require('squid');

var _route = require('xo-wallet-components/src/confirm-upop/route');

var _route2 = _interopRequireDefault(_route);

var _route3 = require('xo-credit-components/src/apply-ppc/route');

var _route4 = _interopRequireDefault(_route3);

require('xo-login-components/src/onetouch-interstitial/route');

var _route5 = require('pages/xo-sidebar/route');

var _route6 = _interopRequireDefault(_route5);

var _directive = require('./directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ReviewRoute = exports.$ReviewRoute = _squid.$ComponentRoute.extend('$ReviewRoute', {

    path: 'review',
    directive: _directive.$xoReviewPageComponent,
    titleContent: 'memberReview.memberReviewTitle',

    trackingData: {
        fptiState: 'review',
        templateName: 'memberReview.dust',
        pageGoal: 'Payment Review',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-review',
                'pagename2': '%::fullpage-review:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },

    children: [{
        route: _route6['default'],
        attributes: {
            'back-uri': 'backUri',
            'promotion': 'promotion',
            'update': 'update',
            'token': 'token',
            'installment': 'installment'
        }
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token',
            'on-complete': 'onComplete'
        }
    }, {
        route: _route2['default'],
        attributes: {
            'token': 'token',
            'cardmodel': 'cardModel',
            'on-success': 'onConfirmUpopSuccess',
            'on-cancel': 'onConfirmUpopCancel'
        }
    }, {
        route: _route4['default'],
        props: function props() {
            return {
                token: this.token
            };
        }
    }]
});

angular.value("$ReviewRoute", $ReviewRoute);
_squid.$ComponentRoute;

_directive.$xoReviewPageComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-review/route.js
 ** module id = 220
 ** module chunks = 1
 **/